import type { RobotReservation } from '@viamrobotics/web-client/robotreservation/v1/robot_reservation';

export const ReservationStates = {
  Queued: 'Queued',
  Lease: 'Lease',
  SettingUpAgent: 'SettingUpAgent',
  Running: 'Running',
  Failed: 'Failed',
  Finished: 'Finished',
} as const;

export const isQueued = (reservation: RobotReservation | undefined) =>
  reservation?.reservationState === ReservationStates.Queued;

export const isLease = (reservation: RobotReservation | undefined) =>
  reservation?.reservationState === ReservationStates.Lease;

export const isFailed = (reservation: RobotReservation | undefined) =>
  reservation?.reservationState === ReservationStates.Failed;

export const isRunning = (reservation: RobotReservation | undefined) =>
  reservation?.reservationState === ReservationStates.Running;

export const isFinished = (reservation: RobotReservation | undefined) =>
  reservation?.reservationState === ReservationStates.Finished;

export const isSettingUpAgent = (reservation: RobotReservation | undefined) =>
  reservation?.reservationState === ReservationStates.SettingUpAgent;
